/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsUserFormatListItem
 */
export interface EfsMelcoEfsModelsUserFormatListItem {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    desc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    display_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    xml_orders_xpath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    unique_field?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    headers?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    config_count?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    type?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof EfsMelcoEfsModelsUserFormatListItem
     */
    updated_date?: Date | null;
}

export function EfsMelcoEfsModelsUserFormatListItemFromJSON(json: any): EfsMelcoEfsModelsUserFormatListItem {
    return EfsMelcoEfsModelsUserFormatListItemFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsUserFormatListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsUserFormatListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'xml_orders_xpath': !exists(json, 'xml_orders_xpath') ? undefined : json['xml_orders_xpath'],
        'unique_field': !exists(json, 'unique_field') ? undefined : json['unique_field'],
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'config_count': !exists(json, 'config_count') ? undefined : json['config_count'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
    };
}

export function EfsMelcoEfsModelsUserFormatListItemToJSON(value?: EfsMelcoEfsModelsUserFormatListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'desc': value.desc,
        'display_name': value.display_name,
        'xml_orders_xpath': value.xml_orders_xpath,
        'unique_field': value.unique_field,
        'headers': value.headers,
        'config_count': value.config_count,
        'type': value.type,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
    };
}


